import type { Label } from "@/api";

// 라벨 추가 시 key 를 먼저 고르지 않고 기존 카탈로그를 가로질러 검색·선택하기 위한 매치.
export type ExistingLabelMatch = {
  uuid: string;
  key: string;
  value: string;
  color: number;
};

export type FilterExistingLabelsOptions = {
  // label 로 추가할 수 없는 key(하드웨어 축). 매치에서 제외한다.
  blockedKeys: readonly string[];
  // 더는 고를 수 없는 key(이미 부여된 단일 카디널리티 reserved 등). 매치에서 제외한다.
  hiddenKeys: readonly string[];
  // 이미 이 대상에 부여된 (key,value). 중복 추가를 막으려 매치에서 제외한다.
  assigned: readonly { key: string; value: string }[];
  limit: number;
};

function pairKey(key: string, value: string): string {
  return `${key} ${value}`;
}

// 카탈로그를 `key:value` 부분 일치(대소문자 무시)로 좁혀 추가 가능한 기존 라벨만 limit 개까지
// 돌려준다. query 가 비면 빈 목록(검색을 시작해야 후보를 노출).
export function filterExistingLabels(
  catalog: readonly Label[],
  query: string,
  { blockedKeys, hiddenKeys, assigned, limit }: FilterExistingLabelsOptions,
): ExistingLabelMatch[] {
  const normalized = query.trim().toLowerCase();
  if (normalized === "") {
    return [];
  }
  const blocked = new Set(blockedKeys);
  const hidden = new Set(hiddenKeys);
  const assignedSet = new Set(assigned.map((label) => pairKey(label.key, label.value)));
  const matches: ExistingLabelMatch[] = [];
  for (const label of catalog) {
    if (blocked.has(label.key) || hidden.has(label.key)) {
      continue;
    }
    if (assignedSet.has(pairKey(label.key, label.value))) {
      continue;
    }
    if (!`${label.key}:${label.value}`.toLowerCase().includes(normalized)) {
      continue;
    }
    matches.push({ uuid: label.uuid, key: label.key, value: label.value, color: label.color });
    if (matches.length >= limit) {
      break;
    }
  }
  return matches;
}
